import { atom } from 'jotai';

export type SignUpStep = 'credentials' | 'complete' | 'success';

export type SignUpState = {
  step: SignUpStep;
  email?: string;
  token?: string;
  organizationId?: string;
  userId?: string;
  completed: boolean;
};

export const $signUp = atom<SignUpState>({
  step: 'credentials',
  completed: false,
});
